var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["afterpay-logo.j2"] = require( "afterpay-logo.j2" );
dependencies["modal/afterpay-info/step1.j2"] = require( "modal/afterpay-info/step1.j2" );
dependencies["modal/afterpay-info/step2-small.j2"] = require( "modal/afterpay-info/step2-small.j2" );
dependencies["modal/afterpay-info/step2.j2"] = require( "modal/afterpay-info/step2.j2" );
dependencies["modal/afterpay-info/step3-small.j2"] = require( "modal/afterpay-info/step3-small.j2" );
dependencies["modal/afterpay-info/step3.j2"] = require( "modal/afterpay-info/step3.j2" );
dependencies["modal/afterpay-info/step4.j2"] = require( "modal/afterpay-info/step4.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/afterpay-info.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"c-afterpay-info-modal-preface\">\n    <div class=\"o-row\">\n        <div class=\"o-column o-extra-small--6 o-medium--4 o-medium--offset-4\">\n            <h2 class=\"c-afterpay-info-modal-preface__heading\">\n                ";
env.getTemplate("afterpay-logo.j2", false, "core/templates/modal/afterpay-info.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n            </h2>\n        </div>\n    </div>\n\n    <div class=\"o-row\">\n        <div class=\"o-column o-extra-small--12\">\n            <h3 class=\"c-afterpay-info-modal-preface__motto\">";
output += runtime.suppressValue((lineno = 11, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["afterpay_info_modal-motto"])), env.opts.autoescape);
output += "</h3>\n        </div>\n    </div>\n</div>\n\n\n<div class=\"o-row c-afterpay-info-modal-process\">\n    <div class=\"o-column o-extra-small--12 o-medium--3 c-afterpay-info-modal-process__inner\">\n        ";
env.getTemplate("modal/afterpay-info/step1.j2", false, "core/templates/modal/afterpay-info.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n        <p class=\"c-afterpay-info-modal-process__copy\">";
output += runtime.suppressValue((lineno = 20, colno = 57, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["afterpay_info_modal-step-1"])), env.opts.autoescape);
output += "</p>\n    </div>\n    <div class=\"o-column o-extra-small--12 o-medium--3 c-afterpay-info-modal-process__inner\">\n        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish")) {
output += "\n            ";
env.getTemplate("modal/afterpay-info/step2-small.j2", false, "core/templates/modal/afterpay-info.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
})});
}
else {
env.getTemplate("modal/afterpay-info/step2.j2", false, "core/templates/modal/afterpay-info.j2", null, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_13.render(context.getVariables(), frame, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
output += t_14
output += "\n        ";
})});
}
output += "\n        <p class=\"c-afterpay-info-modal-process__copy\">";
output += runtime.suppressValue((lineno = 28, colno = 57, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["afterpay_info_modal-step-2"])), env.opts.autoescape);
output += "</p>\n    </div>\n    <div class=\"o-column o-extra-small--12 o-medium--3 c-afterpay-info-modal-process__inner\">\n        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish")) {
output += "\n            ";
env.getTemplate("modal/afterpay-info/step3-small.j2", false, "core/templates/modal/afterpay-info.j2", null, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
t_17.render(context.getVariables(), frame, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
output += t_18
})});
}
else {
env.getTemplate("modal/afterpay-info/step3.j2", false, "core/templates/modal/afterpay-info.j2", null, function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
t_21.render(context.getVariables(), frame, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
output += t_22
output += "\n        ";
})});
}
output += "\n        <p class=\"c-afterpay-info-modal-process__copy\">";
output += runtime.suppressValue((lineno = 36, colno = 57, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["afterpay_info_modal-step-3"])), env.opts.autoescape);
output += "</p>\n    </div>\n    <div class=\"o-column o-extra-small--12 o-medium--3 c-afterpay-info-modal-process__inner\">\n        ";
env.getTemplate("modal/afterpay-info/step4.j2", false, "core/templates/modal/afterpay-info.j2", null, function(t_27,t_25) {
if(t_27) { cb(t_27); return; }
t_25.render(context.getVariables(), frame, function(t_28,t_26) {
if(t_28) { cb(t_28); return; }
output += t_26
output += "\n        <p class=\"c-afterpay-info-modal-process__copy\">";
output += runtime.suppressValue((lineno = 40, colno = 57, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["afterpay_info_modal-step-4"])), env.opts.autoescape);
output += "</p>\n    </div>\n</div>\n\n<div class=\"o-row c-afterpay-info-modal-learn-more\">\n    <div class=\"o-column o-extra-small--12 o-medium--4 o-medium--offset-4\">";
if(runtime.contextOrFrameLookup(context, frame, "showLearnMore")) {
output += "<a class=\"c-afterpay-info-modal-learn-more__a\" href=\"";
output += runtime.suppressValue((lineno = 47, colno = 67, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["afterpay_info_modal-learn-more-link"])), env.opts.autoescape);
output += "\" data-qa-afterpay-modal-learn-more-cta>";
output += runtime.suppressValue((lineno = 47, colno = 149, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["afterpay_info_modal-learn-more"])), env.opts.autoescape);
output += "</a>";
;
}
output += "</div>\n</div>\n\n<div class=\"o-row c-afterpay-info-modal-annotation\">\n    <div class=\"o-column o-extra-small--12\">\n        <p class=\"c-afterpay-info-modal-annotation__p\" data-qa-afterpay-modal-annotation-text>";
output += runtime.suppressValue((lineno = 54, colno = 96, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["afterpay_info_modal-annotation"])), env.opts.autoescape);
output += "</p>\n    </div>\n    <div class=\"o-column o-extra-small--12\">\n        <a href=\"";
output += runtime.suppressValue((lineno = 57, colno = 19, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["afterpay_info_modal-terms-link"])), env.opts.autoescape);
output += "\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"c-afterpay-info-modal-annotation__a\" data-qa-afterpay-modal-annotation-link>";
output += runtime.suppressValue((lineno = 57, colno = 183, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["afterpay_info_modal-terms"])), env.opts.autoescape);
output += "</a>\n    </div>\n</div>";
if(runtime.contextOrFrameLookup(context, frame, "showBackToProduct")) {
output += "<a href=\"#\" class=\"js-back-to-product c-afterpay-info-modal-back-to-product__a\" data-qa-afterpay-modal-back-to-product>";
output += runtime.suppressValue((lineno = 62, colno = 121, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["afterpay_info_modal-back-to-product"])), env.opts.autoescape);
output += "</a>";
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/afterpay-info.j2"] , dependencies)